import Icon from './icon';
import Badge from './badge';
import ButtonIcon from './button';

export {
  Badge,
  ButtonIcon,
};

export default Icon;
